$(function () {
  'use strict';

  var $selector = $('#report-item-departments-selector');
  var $keyword = $('#js-departments-keyword');
  var $selectTargetStepId = $('#js-select-target-step-id');

  var last_search_response = null;

  /**
   * 部署を選択／非選択する
   * @param $checkbox {jQuery}  チェックボックス
   */
  function selectDepartment($checkbox) {
    var $parent = $checkbox.parent();
    if ($checkbox.is(':checked')) {
      $('<input>').attr({type: 'hidden', name: 'departments[]', value: $checkbox.data('department-id')}).appendTo($parent);
    } else {
      $parent.find('input[value="' + $checkbox.data('department-id') + '"]').remove();
    }
  }

  /**
   * 検索フォームが表示されるようスクロールする
   */
  function scrollToForm() {
    var headerOffset = $('#header').height();
    var scrollTop = $(window).scrollTop();
    var viewportHeight = window.innerHeight;
    var formOffsetTop = $('#js-search-form').offset().top;

    // フォームが画面外の場合、スクロールして表示する
    if (scrollTop + headerOffset > formOffsetTop || scrollTop + viewportHeight < formOffsetTop) {
      $('html, body').animate({scrollTop: formOffsetTop - headerOffset}, 500, 'swing');
    }
  }
  // パンくずリストを選択した際の絞り込み
  $selector.on('click', '.search-departments__list__breadcrumb-list__element, .search-departments__list__breadcrumb-list__root', function () {
    if ($(this).data('department-name')) {
      searchByDepartment($(this).data('department-name'));
    } else {
      searchByDepartment("");
    }
  });

  // 部署を選択した際に絞り込み
  $selector.on('click', '.search-departments__list__info__name strong', function () {
    if ($(this).data('department-name')) {
      searchByDepartment($(this).data('department-name'));
    } else {
      searchByDepartment($(this).html());
    }
  });

  /**
   * 部署によるフィルタリング
   * @param department  {string}  部署名
   */
  function searchByDepartment(department) {
    $keyword.val(department.replace(/\uFFFD/g,' '));
    $keyword.trigger('changeKeyword');
    setBreadcrumb(department);
    scrollToForm();
  }

  /**
   * パンくずリストをセットする
   * @param department  {string}  部署名
   */
  function setBreadcrumb(departments) {
    var $breadcrumb = $selector.find('.search-departments__list__breadcrumb-list__element');
    $breadcrumb.remove();

    var $breadcrumbList = $selector.find('.search-departments__list__breadcrumb-list');
    var temp = '';
    var name_with_parents = '';
    departments.split(/\uFFFD/).filter(Boolean).forEach(function (name) {
        name_with_parents = name_with_parents +'\uFFFD'+ name;
        temp += '<span class="search-departments__list__breadcrumb-list__element" data-department-name="' + name_with_parents + '">' + name + '</span>';
    });
    $breadcrumbList.append('<span class=".search-departments__list__breadcrumb-list" style="font-weight: normal;cursor: pointer;">'+ temp + '</span>');
  }

  // 個別部署のcheckbox の on/off で input type=hidden の 追加/削除を行う
  $selector.on('change', 'input[type="checkbox"]' + 'input[data-department-id]', function () {
    selectDepartment($(this));
  });

  var show_records = function () {
    var userRows = '';
    $.each(last_search_response, function (i, item) {
      if ($selector.find('tr[data-department-id="' + item.department.id + '"]').length > 0) return true;

      userRows += buildRow(item.department);
    });
    $selector.append(userRows);
  };

  var timerId = null;

  // キーワード変更
  $keyword.on('changeKeyword', function () {
    var keyword = $(this).val();
    var selectTargetStepId = $selectTargetStepId.val();

    if (timerId) clearTimeout(timerId)

    timerId = setTimeout( function () {
      $.ajax({
        url: '/departments/search.json',
        data: {keyword: keyword, select_target_step_id: selectTargetStepId},
        type: 'get'
      }).done(function (response) {

        // 通信中にkeyword変わってたら何もしない
        if (keyword !== $keyword.val()) return;
        last_search_response = response;

        // 未選択時の案内を削除
        var $notice = $selector.find('tr.notice');
        if ($notice.length > 0) {
            $notice.remove();
        }

        // 表示されている未選択のユーザを削除
        var $unchecked = $selector.find('tr[data-department-id] input[type="checkbox"]:not(:checked)');
        $.each($unchecked, function (i, item) {
            item.parentElement.parentElement.remove();
        });

        // ユーザ一覧を表示
        show_records();
      }).fail(function () {
        console.log('Failed');
      });
    }, 400);
  }).on('keydown', function (e) {
    // 検索キーワード入力中の Enter 押下による submit を無効化
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
      return false;
    }
  });

  /**
   * 行（部署情報）を作成する
   *
   * @param department  {object}
   * @returns           {string}
   */
  function buildRow(department) {
    return (
      '<tr data-department-id="' + department.id + '">' + buildCheckBox(department) + buildThumbnail(department) + buildDepartmentData(department) + '</tr>'
    );
  }

  /**
   * checkbox カラムを作成する
   * checkbox の on/off で input type=hidden の 追加/削除を行う
   *
   * @param department  {object}
   * @returns           {string}
   */
  function buildCheckBox(department) {
    return (
      '<td class="search-departments__list__btn p-l15">' +
      '<input type="checkbox" id="department-' + department.id + '-checkbox" data-department-id="' + department.id + '">' +
      '</td>'
    );
  }

  /**
   * 部署画像のサムネイルカラムを作成する
   *
   * @param department  {object}
   * @returns           {string}
   */
  function buildThumbnail(department) {
    return (
      '<td class="search-departments__list__thumb p-h10">' +
      '<label for="department-' + department.id + '-checkbox">' +
      '<div class="user__thumb user-image--45 img--circled">' +
      '<span style="background-image: url('+department.image_path+'); display: inline-block; background-position: center center; background-repeat: no-repeat; background-size: cover; background-color: #fafafa; width: 45px; height: 45px;"></span>' +
      '</div>' +
      '</label>' +
      '</td>'
    );
  }

  /**
   * 部署情報カラムを作成する
   *
   * @param department  {object}
   * @returns           {string}
   */
  function buildDepartmentData(department) {
    var temp = '';
    var name_with_parents = '';
    $.each(department.departments, function (i, name) {
      name_with_parents = name_with_parents + '\0' + name;
      temp += '<span class="search-departments__list__info__name"><strong data-department-name="' + name_with_parents + '">' + name + '</strong></span>';
    });
    return ('<td class="search-departments__list__info">' + temp + '</td>');
  }

  /**
   * キーワードの変更監視
   * @param fps {number}  イベント実行頻度
   */
  (function keywordObserver(fps) {
    fps = fps || 60;
    var interval = 1000 / fps,
        prevValue = $keyword.val(),
        timerID = null,
        composition = false;

    $keyword.on('compositionstart', function (event) {
      composition = true;
    }).on('compositionend', function (event) {
      composition = false;
    });

    var observe = function (val) {
      // キーワード変更
      if (val !== prevValue && composition === false) {
        $keyword.trigger('changeKeyword');
        prevValue = val;
      }
    };

    // 変更監視
    $keyword.on('focus mouseover', function () {
      if (!timerID) {
        timerID = setInterval(function () {
          observe($keyword.val());
        }, interval);
      }
    }).on('blur', function () {
      clearInterval(timerID);
      timerID = null;
    }).on('mouseout', function () {
      // 検索フォームにフォーカスがある場合は監視継続
      if (!$(':focus').is($keyword)) {
        clearInterval(timerID);
        timerID = null;
      }
    });
  })(5);
});
